module.exports = __webpack_public_path__ + "img/world.f6682f1.svg";